/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
const LABELS = {
  CUSTOMER_ID: "Customer Id",
  REALM_STATUS: "Realm Status",
  REALM_ENVIROMENT_HOST_NAME: "Realm Environment Host Name",
  CUSTOMER_NAME: "Customer Name",
  TENANT_NAME: "Tenant Name",
  NEXT_DEPLOYMENT_AT: "Next Deployment At",
  REALM_TEST_URL: "Realm Test URL",
  REALM_ID_LABEL: "Realm Id",
  REALM_DISPLAY_NAME_LABEL: "Realm Display Name",
  REALM_IDP_LABEL: "Identity Providers",
  REALM_MODULES_LABEL: "Modules",
  REALM_PERMISSIONS_LABEL: "Permissions",
  UNABLE_TO_DISPLAY_IDPS: "Unable to retrieve IDPs",
  COPIED_TO_CLIPBOARD: "{0} copied to clipboard",
  UNABLE_TO_RETRIEVE_PERMISSIONS: "Unable to retrieve permissions",
  NO_PERMISSIONS_FOUND: "No permissions available for this realm module",
  ADMIN: "Admins",
  ROWS_PER_PAGE_LABEL: "Items per page:",
  MAX_TABLE_BODY_HEIGHT: 555,
  IDP_TITLE: "Identity Provider",
  IDP_FIELD_LABEL: "identityProvider.displayName",
  ADMIN_TITLE_LABEL: "Realm Admins",
  ADMIN_FIELD_LABEL: "userName",
  ADMIN_NAME_TITLE: "Name",
  ADMIN_NAME_FIELD: "displayName",
  IDP_ID_FIELD: "idpName",
  NO_ADMINS_FOUND: "No Admins available",
  REALM_ID: "Realm Id",
  REALM_NAME: "Realm Name",
  REALM_COST_CENTER: "Cost Center",
  INSTANCE: "Instance",
  REALM_GEO_LOCATION: "Geo Location",
  REALM_ENVIRONMENT_TYPE: "Environment Type",
  CONTACT_EMAIL: "Contact Email",
  ACCOUNT_ID: "Account Id",
  SECURITY_DOMAIN_ID: "Security Domain Id",
  ACCOUNT_KEY: "Account Key",
  REALM_KEY: "Realm Key",
  ENVIRONMENT_KEY: "Environment Key",
  REALM_RE_PROVISIONING: "Realm Re-Provisioning"
};

const STATUS = {
  PENDING: "Pending",
  PROVISIONING: "Provisioning",
  PROVISIONING_FAILED: "Provisioning Failed",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  DELETED: "Deleted",
  MARKED_FOR_DELETION: "Marked for Deletion",
  BEING_DELETED: "Being Deleted"
};

const MESSAGES = {
  REALM_PUBLIC_HOST_NAME_COPY: "Realm Public Host Name Copied to clipboard",
  REALM_PRIVATE_HOST_NAME_COPY: "Realm Private Host Name Copied to clipboard",
};

export { LABELS, STATUS, MESSAGES };
